<div class="dropdown">
  <div class="dropdown-header flex items-center justify-between">
    <div>
      <div class="dropdown-heading">My Alerts</div>
      <div class="dropdown-subheading" *ngIf="!loading">
        You have {{ notifications.length }} recent alert{{ notifications.length === 1 ? '' : 's' }}.
      </div>
      <div class="dropdown-subheading" *ngIf="loading">Loading alerts…</div>
    </div>
  </div>

  <div class="dropdown-content">
    <a *ngFor="let notification of notifications; trackBy: trackById"
       [class.read]="notification.read"
       class="notification flex items-center"
       matRipple
       (click)="openNotification(notification)">
      <mat-icon [ngClass]="notification.colorClass"
                [svgIcon]="notification.icon"
                class="notification-icon flex-none"></mat-icon>
      <div class="flex-auto min-w-0">
        <div class="notification-badges" *ngIf="notification.eventType || notification.audience">
          <div class="notification-type event-type-label"
               *ngIf="notification.eventType"
               [ngClass]="'event-type--' + (notification.eventTypeTone || 'default')">
            {{ notification.eventType }}
          </div>
          <div class="audience-label"
               *ngIf="notification.audience"
               [ngClass]="'audience--' + (notification.audienceTone || 'default')">
            {{ notification.audience }}
          </div>
        </div>
        <div class="notification-label">{{ notification.label }}</div>
        <div class="notification-description" *ngIf="notification.description">{{ notification.description }}</div>
        <div class="notification-time">{{ notification.datetime | relativeDateTime }}</div>
      </div>
      <mat-icon class="notification-chevron flex-none" svgIcon="mat:chevron_right"></mat-icon>
    </a>

    <div *ngIf="!loading && notifications.length === 0" class="p-4 text-center text-secondary">
      No alerts yet.
    </div>
  </div>

  <div class="dropdown-footer flex items-center justify-center">
    <button color="primary" mat-button type="button" (click)="viewAll()">VIEW ALL</button>
  </div>
</div>
